import { AdminComponent } from './admin.component';
import { MainLayoutComponent } from '@components/main-layout/main-layout.component';
import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { NgxPermissionsGuard } from 'ngx-permissions';

export const adminRoutes: Routes = [
    {
        path: 'admin',
        component: MainLayoutComponent,
        canActivate: [AuthGuard, NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'ADMIN_PANEL',
                redirectTo: '/'
            }
        },
        children: [
            { path: '', component: AdminComponent }
        ]
    }
];
